import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import Bs4GenericField from './Bs4GenericField'

export default class Bs4Password extends Bs4GenericField {

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [showPassword, setShowPassword] = React.useState(false);
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)
    this.refFocus = React.useRef();

    React.useEffect(() => {
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        setValue(this.getValue());
        if (Boolean(error.error)) setError(Bs4GenericField.NO_ERROR);
      })    
    }, [error]);
    
    const handleChange = (event) => {
      this.setValue(event.target.value);
    }

    const handleClickShowPassword = () => {
      setShowPassword(!showPassword);
    };

    const handleMouseDownPassword = (event) => {
      event.preventDefault();
    };

    return (
      <TextField
        inputRef={this.refFocus}   
        fullWidth
        id={this.props.inputId}
        label={<formField.Bs4Label/>} 
        InputLabelProps={this.props.field.hideLabel ? {sx:{display:'none'}} : null}
        value={value}
        type={showPassword ? 'text' : 'password'}
        onChange={handleChange}
        InputProps={{
          endAdornment:(
            <InputAdornment position="end">
              <IconButton onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword}>
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
          readOnly: formField.readOnly
        }}
        error={error.error}
        helperText={error.helperText}
      />
    )
  }
}